import { render, staticRenderFns } from "./UserClientRegisterSystem.vue?vue&type=template&id=6d705567"
import script from "./UserClientRegisterSystem.vue?vue&type=script&lang=js"
export * from "./UserClientRegisterSystem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports